// extracted by mini-css-extract-plugin
module.exports = {"title":"Specs_title__GYrR2","value":"Specs_value__Bhizv"};